import { render, staticRenderFns } from "./CragRoutes.vue?vue&type=template&id=08e61632&scoped=true"
import script from "./CragRoutes.vue?vue&type=script&lang=js"
export * from "./CragRoutes.vue?vue&type=script&lang=js"
import style0 from "./CragRoutes.vue?vue&type=style&index=0&id=08e61632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e61632",
  null
  
)

export default component.exports